import type { components } from '@/lib/openapi.generated'
import { isRecord, json, request, requireNumber, requireString } from '@/lib/api'

type Schemas = components['schemas']
export type PolicyOrderEntry = Schemas['PolicyOrderEntry']
export type PolicyPlacement = { beforePolicyId: string | null; expectedOrder: Schemas['PolicyOrderVersion'][] }
export const policyOrderKeys = {
  all: (entityId: string) => ['policy-order', entityId],
  type: (entityId: string, valueType: string) => ['policy-order', entityId, valueType],
}

export const policyResultKeys = {
  all: (entityId: string) => ['policy-result', entityId],
  type: (entityId: string, valueType: string) => ['policy-result', entityId, valueType],
}

function decodeOrder(raw: unknown): PolicyOrderEntry[] {
  if (!isRecord(raw) || !Array.isArray(raw.items)) throw new Error('Malformed policy order')
  return raw.items.map((item) => {
    if (!isRecord(item)) throw new Error('Malformed policy order entry')
    return { id: requireString(item.id, 'id'), name: requireString(item.name, 'name'), revision: requireNumber(item.revision, 'revision') } satisfies Schemas['PolicyOrderEntry']
  })
}

const path = (entityId: string, valueType: string) => `/api/v1/entities/${entityId}/policies/${encodeURIComponent(valueType)}/order`
export const policyOrderApi = {
  read: (entityId: string, valueType: string) => request(path(entityId, valueType), decodeOrder),
  move: (entityId: string, valueType: string, policyId: string, placement: PolicyPlacement) =>
    request(path(entityId, valueType), (raw) => {
      if (!isRecord(raw)) throw new Error('Malformed policy order receipt')
      return { policyId: requireString(raw.policyId, 'policyId'), revision: requireNumber(raw.revision, 'revision') } satisfies Pick<Schemas['PolicyMutationResult'], 'policyId' | 'revision'>
    }, json('PUT', { policyId, placement: { ...placement, atStart: false } } satisfies Schemas['MovePolicyRequest'])),
}
